import { render, staticRenderFns } from "./GiftBagCard.vue?vue&type=template&id=6233ae88&lang=pug&"
import script from "./GiftBagCard.vue?vue&type=script&lang=ts&"
export * from "./GiftBagCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports